<template>
  <main id="not-found">
    <div class="ria-main-container">
      <img class="m-auto" src="../assets/img/image-error-404.jpg"/>
      <h1 class="text-5xl font-bold text-center">Oops!</h1>
      <div class="text-center mt-2 mb-6">
        <span class="text-xl font-light title-color">Error 404. </span>
        <span class="text-xl font-light">Página no encontrada.</span>
      </div>
      <div class="p-12 bg-white">
        <p class="text-xl font-light text-color">
          La petición URL no se ha encontrado. Quizá no es correcta o tenemos un problema con ella. En cualquier caso puedes:
        </p>
        <br/>
        <router-link :to="{name: 'Home'}">
          <span class="text-xl font-light">Ir a la página principal</span>
        </router-link>
        <br/>
        <router-link :to="{name: 'About'}">
          <span class="text-xl font-light">Contactar con nosotros y explicarnos que esperabas encontrar</span>
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "not-found",
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.title-color, a{
  color: theme('colors.secondary');
}
.text-color{
  color: theme('colors.grey.text');
}
</style>